(function () {
  const ADDON_SKU = "ADD-DIGI-HD";

  // Flag per evitare loop infiniti: quando la sync fa change.js, il fetch-hook non deve rilanciare sync.
  let __INC_IS_SYNCING = false;

  function extractPropertiesFromForm(form) {
    const fd = new FormData(form);
    const props = {};
    for (const [k, v] of fd.entries()) {
      const m = /^properties\[(.+)\]$/.exec(k);
      if (m && v !== "") props[m[1]] = v;
    }
    return props;
  }

  function getCartElement() {
    return document.querySelector("cart-drawer") || document.querySelector("cart-notification");
  }

  function getSectionsToRender(cartEl) {
    if (cartEl && typeof cartEl.getSectionsToRender === "function") {
      try {
        const arr = cartEl.getSectionsToRender() || [];
        // ✅ Dawn vuole SEMPRE "section" quando esiste (non "id")
        const sections = arr
          .map((s) => (s && s.section ? s.section : null))
          .filter(Boolean);

        if (sections.length) return sections;
      } catch (e) {}
    }

    // fallback solo se getSectionsToRender non esiste
    return ["cart-drawer", "cart-icon-bubble", "cart-live-region-text", "cart-footer"];
  }

  function getSubmitter(event) {
    return event.submitter || document.activeElement;
  }

  function renderCart(cartEl, data) {
    if (cartEl && typeof cartEl.renderContents === "function") {
      cartEl.renderContents(data);

      // ✅ Toggle corretto empty/non-empty
      const itemCount =
        (typeof data?.item_count === "number" ? data.item_count : null) ??
        (typeof data?.cart?.item_count === "number" ? data.cart.item_count : null);

      if (itemCount === 0) {
        cartEl.classList.add("is-empty");
      } else if (itemCount !== null) {
        cartEl.classList.remove("is-empty");
      } else {
        // fallback: se non abbiamo info, non tocchiamo
      }

      if (typeof cartEl.open === "function") cartEl.open();
      return true;
    }
    return false;
  }

  async function refreshDrawerUI() {
  const cartEl = getCartElement();
  if (!cartEl || typeof cartEl.renderContents !== "function") {
    // se non c’è il drawer (o non ha renderContents), fallback alla pagina carrello
    window.location.href = window.Shopify.routes.root + "cart";
    return;
  }

  // 1) Prendiamo le sezioni che Dawn vuole aggiornare (ID STRINGA: "cart-drawer", ecc.)
  let sectionIds = [];
  try {
    if (typeof cartEl.getSectionsToRender === "function") {
      const arr = cartEl.getSectionsToRender() || [];
      sectionIds = arr.map((s) => s && s.id).filter(Boolean);
    }
  } catch (e) {}

  // Fallback hardcoded (ma comunque id stringa)
  if (!sectionIds.length) {
    sectionIds = ["cart-drawer", "cart-icon-bubble", "cart-live-region-text", "cart-footer"];
  }

  // 2) Chiediamo al server l’HTML delle sections (IMPORTANTE: su ROOT, non sulla pagina prodotto)
  const params = new URLSearchParams();
  params.set("sections", sectionIds.join(","));

  const url = window.Shopify.routes.root + "?" + params.toString();
  const sectionsRes = await fetch(url, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });

  if (!sectionsRes.ok) throw new Error("sections fetch failed");
  const sections = await sectionsRes.json();

  // 3) Prendiamo item_count reale
  const cart = await fetchCart();

  // 4) Render “alla Dawn”
  cartEl.renderContents({ sections, item_count: cart.item_count });

  // 5) Stato empty coerente
  if (cart.item_count === 0) cartEl.classList.add("is-empty");
  else cartEl.classList.remove("is-empty");

  // 6) Apri drawer
  if (typeof cartEl.open === "function") cartEl.open();
}


  async function fetchCart() {
    const res = await fetch(window.Shopify.routes.root + "cart.js", {
      headers: { Accept: "application/json" },
    });
    return await res.json();
  }

  async function changeLine(line, quantity) {
    const cartEl = getCartElement();
    const sections = getSectionsToRender(cartEl);
    const sectionsUrl = window.location.pathname;

    // ATTENZIONE: qui usiamo "line", che Shopify accetta sempre.
    const res = await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        line,
        quantity,
        sections,
        sections_url: sectionsUrl,
      }),
    });

    const data = await res.json();
    if (cartEl && typeof cartEl.renderContents === "function" && data && data.sections) {
      renderCart(cartEl, data);
    }
    return data;
  }

  function hasAddonOnMain(item) {
    const props = item.properties || {};
    return props["Extra file digitale HD"] === "Sì";
  }

  function getLinkedVariantIdFromAddon(item) {
    const props = item.properties || {};
    return props["_linkato_a_variante"] || null;
  }

  // ✅ Aggiunge main + addon insieme (il tuo blocco che funzionava)
  async function addMainPlusAddon({ form, wrapper, mainVariantId, quantity }) {
    const addonVariantId = Number(wrapper.dataset.addonVariantId || 0);
    if (!addonVariantId) throw new Error("ID variante extra mancante.");

    const mainTitle = wrapper.dataset.mainProductTitle || "";

    // Properties EXTRA (tecniche nascoste)
    const addonProps = {
      "Per prodotto": mainTitle,
      "_linkato_a_variante": String(mainVariantId),
    };

    // Properties PRODOTTO
    const mainProps = extractPropertiesFromForm(form);
    mainProps["Extra file digitale HD"] = "Sì";

    const payload = {
      items: [
        { id: mainVariantId, quantity, properties: mainProps },
        { id: addonVariantId, quantity, properties: addonProps },
      ],
    };

    const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      const msg = data?.description || data?.message || "Errore aggiunta al carrello.";
      throw new Error(msg);
    }

    // ✅ Refresh UI drawer “come Dawn”: evita il bug del drawer bianco
    try {
      await refreshDrawerUI();
    } catch (e) {
      // fallback: se per qualche motivo non riesce a rinfrescare, vai al carrello
      window.location.href = window.Shopify.routes.root + "cart";
    }
  }

  // ✅ Intercetta submit solo se checkbox spuntata
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (!form.action || !/\/cart\/add/.test(form.action)) return;

      const wrapper = form.querySelector("[data-inc-digital-addon]");
      if (!wrapper) return;

      const checkbox = wrapper.querySelector(".inc-digital-addon__checkbox");
      if (!checkbox || !checkbox.checked) return;

      // blocchiamo solo “Aggiungi al carrello”, NON i bottoni rapidi
      const submitter = getSubmitter(e);
      if (submitter && submitter.name && submitter.name !== "add") return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const fd = new FormData(form);
      const mainVariantId = Number(fd.get("id") || 0);
      const quantity = Number(fd.get("quantity") || 1);

      if (!mainVariantId) {
        alert("Non riesco a capire quale variante hai selezionato.");
        return;
      }

      addMainPlusAddon({ form, wrapper, mainVariantId, quantity }).catch((err) => {
        console.error(err);
        alert("Errore: non sono riuscito ad aggiungere l’extra digitale. Riprova.");
      });
    },
    true
  );

  // =========================
  // ✅ SYNC QUANTITÀ (ROBUSTA)
  // - parte DOPO che Dawn ha già aggiornato il carrello (fetch hook)
  // - usa /cart.js per calcolare line e desiderata
  // - aggiorna SOLO le righe extra (sku ADD-DIGI-HD)
  // - se il main non esiste più => rimuove extra
  // =========================

  async function syncDigitalAddons() {
    if (__INC_IS_SYNCING) return;
    __INC_IS_SYNCING = true;

    try {
      const cart = await fetchCart();

      // Mappa: variant_id (prodotto principale) -> qty desiderata (somma)
      const desiredQty = new Map();
      for (const it of cart.items) {
        if (hasAddonOnMain(it)) {
          const k = String(it.variant_id);
          desiredQty.set(k, (desiredQty.get(k) || 0) + it.quantity);
        }
      }

      // Trova le righe extra con la loro LINE (1-based) secondo l'ordine server (/cart.js)
      const addonLines = [];
      for (let i = 0; i < cart.items.length; i++) {
        const it = cart.items[i];
        if (it.sku !== ADDON_SKU) continue;
        addonLines.push({ line: i + 1, item: it });
      }

      // IMPORTANTISSIMO:
      // se dobbiamo rimuovere (qty 0), farlo partendo dalla fine evita shift di linee.
      addonLines.sort((a, b) => b.line - a.line);

      for (const entry of addonLines) {
        const it = entry.item;
        const linked = getLinkedVariantIdFromAddon(it);

        // extra senza link => rimuovi
        if (!linked) {
          await changeLine(entry.line, 0);
          continue;
        }

        const target = desiredQty.get(String(linked)) || 0;

        // main sparito => rimuovi extra
        if (target <= 0) {
          await changeLine(entry.line, 0);
          continue;
        }

        // qty diversa => forza
        if (it.quantity !== target) {
          await changeLine(entry.line, target);
        }
      }
    } catch (err) {
      console.error("Inc sync addon error", err);
    } finally {
      __INC_IS_SYNCING = false;
    }
  }

  // =========================
  // ✅ HOOK FETCH: esegue sync DOPO ogni update cart di Dawn
  // =========================
  (function hookFetchForCartUpdates() {
    const origFetch = window.fetch;

    window.fetch = async function (...args) {
      const res = await origFetch.apply(this, args);

      try {
        // Se stiamo syncando noi, non rilanciare sync
        if (__INC_IS_SYNCING) return res;

        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        const u = String(url);

        // Quando Dawn aggiorna il carrello, aspettiamo un attimo e poi sync
        if (
          u.includes("/cart/change") ||
          u.includes("/cart/update") ||
          u.includes("/cart/add") ||
          u.includes("/cart/clear")
        ) {
          // aspetta che il tema finisca il render
          setTimeout(() => {
            syncDigitalAddons();
          }, 200);
        }
      } catch (e) {}

      return res;
    };
  })();

  // Sync iniziale (se rimane un extra orfano da prove precedenti)
  setTimeout(() => {
    syncDigitalAddons();
  }, 900);

})();
